import { TextSelection } from '@atlaskit/editor-prosemirror/state';

/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */
import { findFirstReplaceStep, getValidEndTextPosition } from '../../pm-plugins/decoration/utils/step-utils';

/**
 * Unsure if we need this - add this 'hook' for now, started with just meta
 * but also folded in `setSelection` logic to reduce that complexity
 *
 * DO NOT pass transaction around beyond here
 */
export function beforeDispatchAITransaction(tr) {
  /**
   * DO NOT REMOVE isAiContentTransformation from transaciton meta.
   * Proactive AI S+G rely on isAiContentTransformation meta to
   * 	ignore changes in document made by AI modal.
   * Why ignore it?
   * - Response returned from AI does not require Spelling and Grammer check.
   * - We have assumed that it's already correct from S+G perspective.
   */
  tr.setMeta('isAiContentTransformation', true);
  const firstReplaceStep = findFirstReplaceStep(tr.steps);
  if (!firstReplaceStep) {
    // eslint-disable-next-line no-console
    console.error('missing transformation step in an AI transaction');
    return tr;
    /**
     * TODO PREEAP handle this case which should never happen
     */
    // throw new Error("There's no new content to set selection to?");
  }
  const validPositionToSet = getValidEndTextPosition({
    step: firstReplaceStep,
    doc: tr.doc
  });
  if (validPositionToSet !== 0) {
    tr.setSelection(TextSelection.create(tr.doc, validPositionToSet));
  }
  return tr;
}